export const R40100 = 40100;
export const R40200 = 40200;
export const R40400 = 40400;
// Semantic version for responses tab minimum requirement
export const MIN_AXON_VERSION_FOR_RESPONSES = '4.31.0';
// Minimum Axon version that ships the c_list_public_user_notifications route
// (AXONCONFIG-5248). Below this the participant event timeline has no backend to read
// notifications from, so its entry point is hidden.
export const MIN_AXON_VERSION_FOR_TIMELINE = '4.37.0';
// Minimum Axon version that ships POST routes/participant/update_email (AXONCONFIG-5268).
// Below this a registered participant's email cannot be changed, so the action is hidden.
export const MIN_AXON_VERSION_FOR_EMAIL_UPDATE = '4.38.0';
